import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";

import { IconComponent } from "../icon";
import styles from "./button-link.module.scss";

export type ButtonLinkProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  dataCy?: string;
  target?: "_blank";
  noArrow?: boolean;
  size?: "md" | "lg";
};

const ButtonLink = ({ children, href, target, dataCy, className, noArrow, size = "md" }: ButtonLinkProps) => {
  return (
    <Link
      data-cy={dataCy}
      target={target}
      className={clsx(styles.root, noArrow && styles.noArrow, size === "lg" && styles.large, className)}
      to={href}
    >
      {children}
      {!noArrow && (
        <div className={styles.arrow}>
          <div className={styles.icon}>
            <IconComponent icon={IcnChevronRight} size="10px" />
          </div>
        </div>
      )}
    </Link>
  );
};

export { ButtonLink };
